import _ from 'lodash';
import { observable } from "mobx";
import AlteraDtaDtcService from "../../../../services/AlteraDtaDtcService";

export default class AlteraDtaDtcStore {

    @observable cobrarde
    @observable codigocobrarde
    @observable labelcobrarde
    @observable documento
    @observable carregar
    
    constructor() {
        /* Dados Consulta */
        this.documento = "";
        this.cobrarde = "";
        this.labelcobrarde = "Cliente / Cobrar de";
        this.carregar = false;
        this.codigocobrarde = 0;

        /* Serviços */
        this.alteraDtaDtcService = new AlteraDtaDtcService();

    };

    setDocumento = (value) => this.documento = value;
    setCobrarDe = (value) => {
        this.labelcobrarde = "Cliente / Cobrar de";
        this.cobrarde = value
    };

    onBlurCobrarDe = async () => {
        this.carregar = true;
        this.codigocobrarde = 0;
        
        let { status, data } = await this.alteraDtaDtcService.obterCliente(this.cobrarde);

        if(status == 200 && data){
            this.codigocobrarde = data.ClibrsClibrsIdSai;
            this.labelcobrarde = `Cliente / Cobrar de ${data.RazaoSocialEmpParcComerc}.`;
            this.carregar = false;
        }else{
            this.carregar = false;
            throw 'Cliente não encontrado.';
        }
    }

    handleFinalizar = async () => {

        this.carregar = true;
        let { status, data } = await this.alteraDtaDtcService.salvar(this.codigocobrarde, this.documento);
        this.carregar = false;

        console.log('DATA:', data);


        if(status == 200 && data){
            return data;
        }else if(status != 200){
            return ["Ocorreu um erro ao finalizar a alteração"];
        }else{
            return [];
        }        
    }
}


// WEBPACK FOOTER //
// ./src/modules/faturamento/dtadtc/store/AlteraDtaDtcStore.js